import { createFileRoute, redirect } from '@tanstack/react-router';
import moment from 'moment';

export const Route = createFileRoute('/application/')({
  component: () => null,
  loader: async () => {
    throw redirect({
      to: '/application/$year/$week/$day/{-$shiftId}',
      params: {
        year: moment().isoWeekYear().toString(),
        week: moment().isoWeek().toString(),
        day: moment().weekday().toString(),
      },
    });
  },
});
